export default __webpack_public_path__ + "static/media/tweets3.7f92112f.png";